const API = {
  BASE_URL: "https://cabezafeliciano.adv.br/api/v1",
  PATH: {
    ME: "/me",
    SIGNIN: "/login",

    // avatar
    ME_AVATAR: "/me/avatar",

    // reminders
    ME_REMINDERS: "me/reminders",

    // customers
    CUSTOMERS: "/customers",
    CUSTOMERS_ASSIGNMENT: (id: string) => `/customers/assignment_enabled/${id}`,
    CUSTOMERS_ADDITIONAL_INFORMATIONS: (uuid: string) => `/customers/${uuid}/additional-informations`,
    CUSTOMERS_ADDRESSES: (uuid: string) => `/customers/${uuid}/addresses`,
    CUSTOMERS_DOCUMENTS: (uuid: string) => `/customers/${uuid}/upload-files`,
    CUSTOMERS_LIBRARY_DOCUMENTS: (uuid: string) => `/customers/${uuid}/documents`,
    CUSTOMERS_DOCUMENTS_AGREEMENTS: (uuid: string) => `/customers/${uuid}/upload-file-agreements`,
    PROCESS_DOCUMENTS_AGREEMENTS: (process_number: string) => `/process_number_upload_files_agreements/by_process_number/${process_number}`,
    CUSTOMERS_BANK_ACCOUNTS: (uuid: string) => `/customers/${uuid}/bank-accounts`,
    CUSTOMERS_EMAILS: (uuid: string) => `/customers/${uuid}/emails`,
    CUSTOMERS_HEALTH_CONDITIONS: (uuid: string) => `/customers/${uuid}/health-conditions`,
    CUSTOMERS_HEALTH_CONDITIONS_FILE: (uuid: string) => `/customers/${uuid}/health-condition-files`,
    CUSTOMERS_LEGAL_ACTIONS: (uuid: string) => `/customers/${uuid}/legal-actions`,
    CUSTOMERS_PHONES: (uuid: string) => `/customers/${uuid}/phones`,
    CUSTOMERS_WORKS: (uuid: string) => `/customers/${uuid}/works`,
    CUSTOMERS_RECEIPTS: (uuid: string) => `/customers/${uuid}/bank-receipts`,
    CUSTOMERS_RECEIPTS_SIMPLE: `/customers/bank-receipts`,
    ATTACHEMENTS_GENERATE_DOCUMENTS: "/attachments/generate-documents",
    ATTACHEMENTS_GENERATE_DOCUMENTS_SUCCESSOR: "/attachments/generate-documents-successor",
    CUSTOMERS_DEATH_CERTIFICATION: (uuid: string) => `/customers/${uuid}/death-certifications`,
    CUSTOMERS_PROCESS_PHASES: (uuid: string) => `/customers/${uuid}/process-phases`,

    // successors
    SUCCESSORS: "/successors",

    SUCCESSORS_CONTACTS: (uuid: string) => `/successors/${uuid}/contacts`,
    SUCCESSOR_ADDRESS: (uuid: string) => `/successors/${uuid}/addresses`,
    SUCCESSORS_BANK_ACCOUNTS: (uuid: string) => `/successors/${uuid}/bank-accounts`,
    SUCCESSORS_WORKS: (uuid: string) => `/successors/${uuid}/works`,
    SUCCESSORS_HEALTH_CONDITIONS: (uuid: string) => `/successors/${uuid}/health-conditions`,
    SUCCESSORS_DEATH_CERTIFICATION: (uuid: string) => `/successors/${uuid}/death-certifications`,
    SUCCESSORS_FILE: (uuid: string) => `/successors/${uuid}/files`,
    SUCCESSORS_FILES_AGREEMENTS: (uuid: string) => `/successors/${uuid}/file-agreements`,

    // precatories
    PRECATORY: "/precatories",
    PRECATORY_EXCEL: "/precatories/import-excel",

    // users
    USERS: "/users",
    USERS_PASSWORD_RESET: "/users/password-reset",

    // calendar
    CALENDAR_EVENTS: "/calendar-events",
    CALENDAR_EVENTS_EXCEL: "/calendar-events/import-excel",

    // calendar invited user
    CALENDAR_EVENTS_INVITED_USERS: (eventUuid: string, userUuid: string) => `/calendar-events/${eventUuid}/users/${userUuid}`,

    //pje
    PJE_CUSTOMER_PROCESSES: "/pje-customer-processes",
    PJE_SEARCH: "pje-customer-processes/search-name-or-cpf",
    PJE_CUSTOMER_ID: (pjeCustomerId: number | string) => `/pje-customer-processes/search-process-by-customer-id-pje?pje_customer_id=${pjeCustomerId}`,
    PJE_PROCESS_ID: (pjeProcessId: string) => `/pje-customer-processes/search-process-id-pje?pje_process_id=${pjeProcessId}`,
    PJE_DOCUMENTS_ID: (pjeDocumentId: string) => `/pje-customer-processes/document?pje_document_id=${pjeDocumentId}`,
    PJE_CUSTOMER_PROCESSES_UUID: (uuid: string) => `pje-customer-processes/${uuid}`,
    PJE_GET_CUSTOMER_PROCESSES_UUID: (uuid: string) => `pje-customer-processes/process-by-customer-uuid?customer_uuid=${uuid}`,
    PJE_SEND_TOKEN: (token: string) => `pje-customer-processes/send-token?token=${token}`,

    //pubications
    PUBLICATIONS: "/oab/search-diario",

    // notifications
    NOTIFICATIONS: "/notifications/",

    // cliente notes
    CLIENTENOTES: "/cliente_notes",

    CLIENTENOTESHOME: "/cliente_notes/home/",
  },
};

export { API };
